export default "__VITE_ASSET__C4tQUFhu__"